export enum CHANNEL_OTP {
  EMAIL = 'CHANNEL_EMAIL',
  SMS = 'CHANNEL_SMS',
  WHATSAPP = 'CHANNEL_WHATSAPP',
  UNSPECIFIED = 'CHANNEL_UNSPECIFIED',
  PROMPT = 'CHANNEL_PROMPT',
}

export enum PROMPT_STATUS {
  PROMPT_STATUS_UNSPECIFIED = 'PROMPT_STATUS_UNSPECIFIED',
  PROMPT_STATUS_PENDING = 'PROMPT_STATUS_PENDING',
  PROMPT_STATUS_APPROVED = 'PROMPT_STATUS_APPROVED',
  PROMPT_STATUS_REJECTED = 'PROMPT_STATUS_REJECTED',
  PROMPT_STATUS_EXPIRED = 'PROMPT_STATUS_EXPIRED',
}

export type TLoginType =
  | 'LOGIN_DATA_TYPE_UNSPECIFIED'
  | 'LOGIN_DATA_TYPE_SUCCESS'
  | 'LOGIN_DATA_TYPE_NEW_DEVICE'
  | 'LOGIN_DATA_TYPE_TRUSTED_DEVICE';

export type TOtpRecipients = {
  channel: CHANNEL_OTP;
  target: string;
}[];

export type TNewDevice = {
  token: string;
  otpRecipients: {
    channel: CHANNEL_OTP;
    value: string;
  }[];
};

export type TFormVerifyIdentity = {
  ktp: { value: string; error: string };
  dob: { value: string; error: string };
  bankAccount: { value: string; error: string };
  mothersName: { value: string; error: string };
};
